import React, { Component, PropTypes } from 'react'

/* Utilities */
import _ from 'lodash'

import { Icon, ICON, SCHEME as ICON_SCHEME } from 'widget/icon'

/* Styles */
import './item.css'

/* Single Playlist List Item */
export default class SortToolbarItem extends Component {

    getClassName() {
        const {
            className,
            selected
        } = this.props
        let classNameArr = className ?className.split(' '):[]
        classNameArr.push('sort-toolbar-item', 'widget')
        if (selected) classNameArr.push('selected')
        return  classNameArr.join(' ')
    }

    renderIcon() {
        const {
            reverse,
            selected
        } = this.props
        const scheme = selected?ICON_SCHEME.DARK:ICON_SCHEME.DEFAULT
        if (reverse) return <Icon icon={ ICON.CARET_UP } size={ 16 } scheme={ scheme }/>
        return <Icon icon={ ICON.CARET_DOWN } size={ 16 } scheme={ scheme }/>
    }

    onLabelClick(e) {
        const {
            reverse,
            name,
            selected,
            onSelect,
        } = this.props
        if (selected) onSelect(name, !reverse)
        else onSelect(name, reverse)
    }

    onReverseClick(e) {
        const {
            reverse,
            name,
            selected,
            onSelect,
        } = this.props

        if (selected) onSelect(name, !reverse)
        else onSelect(name, reverse)
    }

    render() {
        const {
            label
        } = this.props
        return (
            <li
                className={ this.getClassName() }
            >
                <div
                    className="label"
                    onClick={ this.onLabelClick.bind(this) }
                >
                    { label }
                </div>
                <div
                    className="toggle-reverse"
                    onClick={ this.onReverseClick.bind(this) }
                >
                    { this.renderIcon() }
                </div>
            </li>
        )
    }
}

SortToolbarItem.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    selected: PropTypes.bool,
    reverse: PropTypes.bool,
    title: PropTypes.string,
    onSelect: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/app/widget/sort-toolbar/item.jsx